import { Country, IndexedSchoolSuggestion } from '@lessonup/typescript-core/domain';
import { SchoolSelect } from '@lessonup/typescript-core/ui';
import React from 'react';
import { useAppServices } from '../../../../../../components/appServices/AppServicesContext';
import useFeatureFlags from '../../../../../../utils/featureFlags/useFeatureFlags';

interface SchoolSuggestorProps {
  countryCode?: Country.CountryCode;
  onSelect: (school: IndexedSchoolSuggestion) => void;
  onSetManualEntry: (val: string) => void;
  hasError: boolean;
  invalidateError: () => void;
  onChange?: (school: IndexedSchoolSuggestion | undefined) => void;
}

export const SchoolSuggestor: React.FC<SchoolSuggestorProps> = (props) => {
  const services = useAppServices();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- auto-generated TECH-258
  const { isFeatureFlagEnabled } = useFeatureFlags();

  function getSuggestions(params: { countryCode: Country.CountryCode; query: string }) {
    return services.schoolPicker.getSchoolPickerSuggestions({
      ...params,
    });
  }

  return (
    <SchoolSelect
      countryCode={props.countryCode}
      onSubmit={props.onSelect}
      getSuggestions={getSuggestions}
      onSetManualEntry={props.onSetManualEntry}
      hasError={props.hasError}
      invalidateError={props.invalidateError}
      onChange={props.onChange}
    />
  );
};
